// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { isNonEmptyString } from '@utils/type-checkers'
import { createResponseObj } from '..'
import { vcBaseUrl } from '.'


type GetGroupResponse = (SuccessResponse & {
    group: Group
}) | FailedResponse

export class GetGroupRequest extends Request {
    private constructor(groupId: string, init?: RequestInit) { super(`${vcBaseUrl}/group/${groupId}`, init) }
    static async init(groupId: string | undefined, init?: RequestInit) {
        if (!isNonEmptyString(groupId)) throw createResponseObj<FailedResponse>({ status: 'failed', type: 'local', name: 'invalid-group-id ', message: 'Invalid Id' })
        else return new GetGroupRequest(groupId, {
            ...init,
            method: 'GET',
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<Group> {
        const response = await fetch(this)
        const data = createResponseObj<GetGroupResponse>(await response.json())
        console.info("Get Group Results:", data)
    
        switch (data.status) {
            case 'successful': return data.group
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}